import * as constants from '../constants';

const APP_HEADER_ID = 'app-header';
export const PREVIEW_ROUTE_HEADER_CLASS = 'evergreen-preview-route';
const PREVIEW_PATH_RE = /^\/books\/[^/]+\/preview(\/|$)/;

let previewHeaderObserver = null;

export const isBookPreviewRoute = () => PREVIEW_PATH_RE.test(window.location.pathname);

const setPreviewRouteHeaderSuppressed = (suppressed) => {
  document.documentElement.classList.toggle(PREVIEW_ROUTE_HEADER_CLASS, suppressed);
};

const ensurePreviewHeaderHidden = () => {
  const header = document.getElementById(APP_HEADER_ID);
  if (header) {
    header.style.display = 'none';
  }
};

const startPreviewHeaderObserver = () => {
  if (previewHeaderObserver) {
    return;
  }
  previewHeaderObserver = new window.MutationObserver(() => {
    if (isBookPreviewRoute()) {
      setPreviewRouteHeaderSuppressed(true);
      ensurePreviewHeaderHidden();
    }
  });
  previewHeaderObserver.observe(document.documentElement, { childList: true, subtree: true });
};

const stopPreviewHeaderObserver = () => {
  if (previewHeaderObserver) {
    previewHeaderObserver.disconnect();
    previewHeaderObserver = null;
  }
};

export const hideAppHeader = () => {
  setPreviewRouteHeaderSuppressed(true);
  ensurePreviewHeaderHidden();
};

// force when leaving preview (see PdfViewerContainer unmount)
export const showAppHeader = (force = false) => {
  if (!force && isBookPreviewRoute()) {
    return;
  }
  stopPreviewHeaderObserver();
  setPreviewRouteHeaderSuppressed(false);
  const header = document.getElementById(APP_HEADER_ID);
  if (header) {
    header.style.removeProperty('display');
  }
};

export const shouldHideAppHeaderForPreview = (titleType) =>
  titleType === constants.ETEXT2_PXE_TITLE || titleType === constants.RPLUS_EPUB_TITLE;

export const syncAppHeaderVisibilityForPreview = (titleType) => {
  if (shouldHideAppHeaderForPreview(titleType)) {
    hideAppHeader();
    return;
  }
  if (isBookPreviewRoute() && !titleType) {
    hideAppHeader();
    return;
  }
  showAppHeader();
};

// inline script in index.html calls this before React boots
export const initAppHeaderForPreviewRoute = () => {
  if (!isBookPreviewRoute()) {
    return;
  }
  hideAppHeader();
  startPreviewHeaderObserver();
};
